import React from 'react';
import { withTracker } from 'meteor/react-meteor-data';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { Box, Typography, Stack, CircularProgress, Paper } from '@mui/material';
import { map, isEqual, isEmpty } from 'lodash';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { renderIconButton } from '../MaterialMUIComponent';

import Annotations from '../../../api/Annotations/Annotations';
import * as annotationsOps from '../../../api/Annotations/annotation-operations';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

import ViewAnnotation from '../ViewAnnotation';

const ViewAnnotationOneByOne = ({
  loading,
  totalDocuments,
  element,
  index,
  onIndexChange,
  ...rest
}) => {
  const textTable = !isEqual(totalDocuments, 0)
    ? `${index + 1}/${totalDocuments}`
    : `${0}/${totalDocuments}`;

  const handlePrevious = () => {
    if (index > 0) {
      onIndexChange(index - 1);
    }
  };

  const handleNext = () => {
    if (index < totalDocuments - 1) {
      onIndexChange(index + 1);
    }
  };

  const renderManyIconButtons = array =>
    map(
      array,
      item =>
        item.isShow &&
        renderIconButton({
          key: item.key,
          onClick: item.onClick,
          icon: item.icon,
          titleTooltip: item.title,
          disabled: totalDocuments <= 0 || item.disabled,
          style: { padding: 0 }
        })
    );
  const renderIconAnnotation = () => {
    const template = annotationsOps.getTemplate(element);
    const library = templateOps.getLibraryIcon(template);
    const icon = templateOps.getIcon(template);
    const svgIcon = templateOps.getIconSvg(template);
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME)
      return <FontAwesomeIcon icon={icon} style={{ color: '#2A3F90' }} />;
    if (library === LIBRARY_ICON_TYPES.SVG)
      return (
        <img
          src={svgIcon}
          alt={icon}
          style={{ marginRight: '5px', width: '20px', height: '20px' }}
        />
      );
    return <FontAwesomeIcon icon={icon} />;
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
        <Typography marginLeft={2}>Cargando anotaciones...</Typography>
      </Box>
    );
  }

  return (
    <Paper sx={{ padding: 0, margin: 0 }}>
      {!isEmpty(element) && (
        <Stack
          key="row2-annotations"
          direction="row"
          display="flex"
          justifyContent="center"
          style={{ backgroundColor: 'white', borderColor: 'white' }}
        >
          <Typography style={{ height: '100%', fontSize: '15px' }}>
            {templateOps.getName(annotationsOps.getTemplate(element))}
          </Typography>
        </Stack>
      )}
      <Stack
        key="row1-column1-annotations"
        direction="row"
        display="flex"
        justifyContent="space-around"
        style={{ backgroundColor: 'white', borderColor: 'white' }}
      >
        <Stack direction="row" display="flex" justifyContent="flex-start">
          {renderManyIconButtons([
            {
              isShow: !isEmpty(element),
              key: 'boton-goStart-annotation',
              onClick: () => onIndexChange(0),
              icon: <KeyboardDoubleArrowLeftIcon style={{ color: '#2A3F90' }} />,
              titleTooltip: 'Start Annotation'
            },
            {
              isShow: !isEmpty(element),
              key: 'boton-previous-annotation',
              onClick: () => handlePrevious(),
              icon: <KeyboardArrowLeftIcon style={{ color: '#2A3F90' }} />,
              titleTooltip: 'Previous Annotation'
            }
          ])}
        </Stack>

        <Stack direction="row" display="flex" justifyContent="center">
          <Typography
            style={{ height: '100%', marginTop: '10%', fontSize: '15px', marginRight: '20%' }}
          >
            {textTable}
          </Typography>
          {renderManyIconButtons([
            {
              isShow: !isEmpty(element),
              key: 'annotation-icon',
              onClick: () => {},
              icon: !isEmpty(element) ? renderIconAnnotation() : <></>,
              titleTooltip: '',
              disabled: true
            }
          ])}
        </Stack>
        <Stack direction="row" display="flex" justifyContent="flex-end">
          {renderManyIconButtons([
            {
              isShow: !isEmpty(element),
              key: 'boton-next-annotation',
              onClick: () => handleNext(),
              icon: <KeyboardArrowRightIcon style={{ color: '#2A3F90' }} />,
              titleTooltip: 'Next Annotation'
            },
            {
              isShow: !isEmpty(element),
              key: 'boton-goLast-annotation',
              onClick: () => onIndexChange(totalDocuments - 1),
              icon: <KeyboardDoubleArrowRightIcon style={{ color: '#2A3F90' }} />,
              titleTooltip: 'Last Annotation'
            }
          ])}
        </Stack>
      </Stack>
      <Box sx={{ padding: 0, margin: 0 }}>
        {element && (
          <ViewAnnotation
            annotation={element}
            changeVideoContainerStateProperty={() => {}}
            isPublic
            showCloseButton={false}
            {...rest}
          />
        )}
      </Box>
    </Paper>
  );
};

ViewAnnotationOneByOne.defaultProps = {
  element: null
};

ViewAnnotationOneByOne.propTypes = {
  loading: PropTypes.bool.isRequired,
  totalDocuments: PropTypes.number.isRequired,
  element: PropTypes.object,
  index: PropTypes.number.isRequired,
  onIndexChange: PropTypes.func.isRequired
};

export default withTracker(({ index, order = 1, videoId, sortField = 'videoTime' }) => {
  const annotationSub = Meteor.subscribe('annotations.video', videoId);
  const isReady = annotationSub.ready();

  let totalDocuments = 0;
  let element = null;

  if (isReady) {
    const filters = { 'geoJSON.properties.video': videoId };
    totalDocuments = Annotations.find(filters).count();
    element =
      Annotations.find(filters, {
        sort: { [sortField]: order },
        skip: index,
        limit: 1
      }).fetch()[0] || null;
  }

  return {
    loading: !isReady,
    totalDocuments,
    element
  };
})(ViewAnnotationOneByOne);
